// hooks/useModals.js
import { useState } from 'react';

export const useModals = () => {
  // Modal states
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [confirmCreateModalOpen, setConfirmCreateModalOpen] = useState(false);
  const [confirmEditModalOpen, setConfirmEditModalOpen] = useState(false);
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [confirmDeleteItemModalOpen, setConfirmDeleteItemModalOpen] = useState(false);
  const [resendModalOpen, setResendModalOpen] = useState(false);
  const [progressModalOpen, setProgressModalOpen] = useState(false);

  // View modal states
  const [viewFileModalOpen, setViewFileModalOpen] = useState(false);
  const [viewPasswordModalOpen, setViewPasswordModalOpen] = useState(false);
  const [viewCardModalOpen, setViewCardModalOpen] = useState(false);
  const [viewBlockchainModalOpen, setViewBlockchainModalOpen] = useState(false);

  const [confirmDeleteFolderModalOpen, setConfirmDeleteFolderModalOpen] = useState(false);
const [folderToRemove, setFolderToRemove] = useState(null);

  // Current item for viewing
  const [currentItem, setCurrentItem] = useState(null);
  const [itemToRemove, setItemToRemove] = useState(null);

  // Add modal specific states
  const [currentAddPath, setCurrentAddPath] = useState([]);
  const [addModalSearchTerm, setAddModalSearchTerm] = useState('');
  const [addModalFilterOption, setAddModalFilterOption] = useState('all');

  // Open modals
  const openDeleteModal = () => setDeleteModalOpen(true);
  const openConfirmCreateModal = () => setConfirmCreateModalOpen(true);
  const openConfirmEditModal = () => setConfirmEditModalOpen(true);
  const openTermsModal = () => setTermsModalOpen(true);
  const openAddModal = () => {
    setCurrentAddPath([]);
    setAddModalSearchTerm('');
    setAddModalFilterOption('all');
    setAddModalOpen(true);
  };
  const openConfirmDeleteItemModal = (item) => {
    setItemToRemove(item);
    setConfirmDeleteItemModalOpen(true);
  };
  const openResendModal = () => setResendModalOpen(true);
  const openProgressModal = () => setProgressModalOpen(true);

  // Close modals
  const closeDeleteModal = () => setDeleteModalOpen(false);
  const closeConfirmCreateModal = () => setConfirmCreateModalOpen(false);
  const closeConfirmEditModal = () => setConfirmEditModalOpen(false);
  const closeTermsModal = () => setTermsModalOpen(false);
  const closeAddModal = () => setAddModalOpen(false);
  const closeConfirmDeleteItemModal = () => {
    setConfirmDeleteItemModalOpen(false);
    setItemToRemove(null);
  };
  const closeResendModal = () => setResendModalOpen(false);
  const closeProgressModal = () => setProgressModalOpen(false);

  // View modal handlers
  const openViewFileModal = (item) => {
    setCurrentItem(item);
    setViewFileModalOpen(true);
  };

  const openViewFileModalReceived = (item) => {
    setCurrentItem(item);
    setViewFileModalOpen(true);
  };
  
  const closeViewFileModal = () => {
    setViewFileModalOpen(false);
    setCurrentItem(null);
  };

  const openViewPasswordModal = (item) => {
    setCurrentItem(item);
    setViewPasswordModalOpen(true);
  };
  const closeViewPasswordModal = () => {
    setViewPasswordModalOpen(false);
    setCurrentItem(null);
  };

  const openViewCardModal = (item) => {
    setCurrentItem(item);
    setViewCardModalOpen(true);
  };
  const closeViewCardModal = () => {
    setViewCardModalOpen(false);
    setCurrentItem(null);
  };

  const openViewBlockchainModal = (item) => {
    setCurrentItem(item);
    setViewBlockchainModalOpen(true);
  };
  const closeViewBlockchainModal = () => {
    setViewBlockchainModalOpen(false);
    setCurrentItem(null);
  };

  // Add modal navigation
  const handleAddModalCategoryClick = (category) => {
    setCurrentAddPath([...currentAddPath, category]);
  };

  const handleAddModalBackClick = () => {
    if (currentAddPath.length === 0) return;
    const newPath = [...currentAddPath];
    newPath.pop();
    setCurrentAddPath(newPath);
  };

  const resetAddModalState = () => {
    setCurrentAddPath([]);
    setAddModalSearchTerm('');
    setAddModalFilterOption('all');
  };

  const openConfirmDeleteFolderModal = (folder) => {
  setFolderToRemove(folder);
  setConfirmDeleteFolderModalOpen(true);
};

const closeConfirmDeleteFolderModal = () => {
  setConfirmDeleteFolderModalOpen(false);
  setFolderToRemove(null);
};

  // Close all modals
  const closeAllModals = () => {
    setDeleteModalOpen(false);
    setConfirmCreateModalOpen(false);
    setConfirmEditModalOpen(false);
    setTermsModalOpen(false);
    setAddModalOpen(false);
    setConfirmDeleteItemModalOpen(false);
    setResendModalOpen(false);
    setProgressModalOpen(false);
    setViewFileModalOpen(false);
    setViewPasswordModalOpen(false);
    setViewCardModalOpen(false);
    setViewBlockchainModalOpen(false);
    setCurrentItem(null);
    setItemToRemove(null);
    resetAddModalState();
  };

  return {
    // Modal states
    deleteModalOpen,
    confirmCreateModalOpen,
    confirmEditModalOpen,
    termsModalOpen,
    addModalOpen,
    confirmDeleteItemModalOpen,
    resendModalOpen,
    progressModalOpen,
    confirmDeleteFolderModalOpen,
  folderToRemove,
  openConfirmDeleteFolderModal,
  closeConfirmDeleteFolderModal,
    viewFileModalOpen,
    viewPasswordModalOpen,
    viewCardModalOpen,
    viewBlockchainModalOpen,

    // Current items
    currentItem,
    itemToRemove,

    // Add modal states
    currentAddPath,
    addModalSearchTerm,
    addModalFilterOption,

    // Setters
    setCurrentAddPath,
    setAddModalSearchTerm,
    setAddModalFilterOption,

    // Open handlers
    openDeleteModal,
    openConfirmCreateModal,
    openConfirmEditModal,
    openTermsModal,
    openAddModal,
    openConfirmDeleteItemModal,
    openResendModal,
    openProgressModal,
    openViewFileModal,
    openViewPasswordModal,
    openViewCardModal,
    openViewBlockchainModal,
    openViewFileModalReceived,

    // Close handlers
    closeDeleteModal,
    closeConfirmCreateModal,
    closeConfirmEditModal,
    closeTermsModal,
    closeAddModal,
    closeConfirmDeleteItemModal,
    closeResendModal,
    closeProgressModal,
    closeViewFileModal,
    closeViewPasswordModal,
    closeViewCardModal,
    closeViewBlockchainModal,

    // Add modal navigation
    handleAddModalCategoryClick,
    handleAddModalBackClick,
    resetAddModalState,

    // Utility
    closeAllModals
  };
};